module.exports = __webpack_public_path__ + "8778ef1c733b01e63cc9a516b3d55fa3.svg";